module.exports = __webpack_public_path__ + "public/img/使用指南-2.3c4b882e.png";